import { useCallback } from "react";
import {
  getCustomColumnsWithGroup,
  getCustomElementColumnDetailList,
} from "../../api/WorkOrders";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetCustomFields() {
  const setCustomFields = useWorkOrderStore(
    (state) => state.setWoCustomElementColumnDetail
  );
  const getCustomFields = useCallback(
    async (woNumber: string, subCategory?: string) => {
      const response = subCategory
        ? await getCustomColumnsWithGroup(undefined, subCategory)
        : await getCustomElementColumnDetailList();
      if (!response.isError) {
        setCustomFields(
          woNumber,
          subCategory ? response.data.fields : response.data
        );
      }
      return response;
    },
    [setCustomFields]
  );

  return { getCustomFields };
}
